import { render } from "./MemorizeYourBirthday.vue?vue&type=template&id=08b3b5a8&scoped=true"
import script from "./MemorizeYourBirthday.vue?vue&type=script&lang=js"
export * from "./MemorizeYourBirthday.vue?vue&type=script&lang=js"

import "./MemorizeYourBirthday.vue?vue&type=style&index=0&id=08b3b5a8&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.member/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08b3b5a8"]])

export default __exports__